<template>
  <div class="page-home page-wrapper">
    <div class="pc" v-if="!isPhone">
      <!-- <div class="imgcenter">
        <img src="./../assets/img/header_img.png" alt />
      </div> -->
      <div class="content-wrapper clearfix">
      <!-- Banner区域 -->
      <div class="swiperBanner clearfix" v-if="swiperData && swiperData.length >= 3" >
        <div class="swiper-container banner-swiper fLeft">
          <div class="swiper-wrapper">
            <div class="swiper-slide pointer" v-for="(item, i) in swiperData" :key="i">
                <div class="img bgc-default">
                  <img :src="item.img169 || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                  <span v-show="item.newsKind == 4" class="video-icon"></span>
                </div>
            </div>
          </div>
          <div class="swiper-toLeft swiper-arrow arrow-wrapper">
            <div class="arrow-wrapper"></div>
          </div>
          <div class="swiper-toRight swiper-arrow arrow-wrapper">
            <div class="arrow-wrapper"></div>
          </div>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </div>
        <div class="swiper-title" :class="swiperData.length && swiperData.length === 4 && 'spaceBetween'">
          <div class="swiper-title-item" :class="swiper && swiper.realIndex === i && 'active'" 
          @mouseenter="mouseEnter(i)" @click="bannerClick(i)" v-for="(item, i) in swiperData" :key="i">
           <div>
              <div class="line-2 title">
                {{item.title}}
              </div>
              <div class="desc">
                <div class="sourcename"><div class="line-2">{{item.sourceName}}</div></div>
                <div class="publishtime">{{item.publishShowTime}}</div>
              </div>
           </div>
          </div>
        </div>
      </div>
      <div :class="[hasSubject ? 'content-wrapper-left' :'content-wrapper-NC']">
        <!-- 最新辟谣 -->
        <div class="latest-kill-rumor">
          <div class="common-title">
            <span @click="update">最新辟谣</span>
          </div>
          <div class="list">
            <div v-if="indexChannel && indexChannel.channelId">
              <NewsList :column="column" :list="beforeList" :type="7" :channelId="indexChannel.channelId" :channelType="indexChannel.channelType" />
              <NewsList :column="column" :list="list" :type="7" :channelId="indexChannel.channelId" :channelType="indexChannel.channelType" />
            </div>
          </div>
        </div>
        <div class="loadMore pointer" @click="update">
          {{isLoading ? '加载更多...' : (lastDataId == -1 ? '已经到底了' : '点击加载更多')}}
        </div>
      </div>
      <div v-if="hasSubject" class="content-wrapper-right" :class="[aside_fixed ? 'aside_fixed' : '', aside_absolute ? 'aside_absolute' : '' ]" id="content-wrapper-right">
        <div class="aside-subject" v-for="item in recommendColumn"  v-if="item.subject && item.subject.newsList && item.subject.newsList.length">
          <div class="common-title title-name line-1"><span>{{item.name}}</span></div>
          <div class="news-part">
            <div class="news pointer" v-for="($item, $index) in item.subject.newsList" v-show="$index < 5" @click="toNewsDetail($item)">
              <div class="news-title line-2" :title="$item.title">
                {{$item.title}}
              </div>
              <div class="news-meta">
                <span v-show="$item.sourceName">{{$item.sourceName}}</span>
                <span v-show="$item.publishShowTime">{{$item.publishShowTime}}</span>
              </div>
            </div>
            <div class="seeAll pointer" v-show="showSeeAll(item)" @click="toDetail(item, true)">
              查看全部
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="wap" v-if="isPhone">
      <div class="content-wrapper">
        <div v-if="swiperData && swiperData.length >= 3" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in swiperData" :key="i" @click="toNewsDetail(item, true)">
                <div class="img">
                  <img :src="item.img169 || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                  <span v-show="item.newsKind == 4" class="video-icon"></span>
                </div>
                <div class="title"> 
                  <div class="titleName line-2">
                    <span v-show="item.isSubjectEntrance || item.extKind == 2" class="label-banner-wap" :class="{'label-activity': !item.isSubjectEntrance && item.extKind == 2}">{{item | newsKind}}</span>
                    {{item.title}}
                  </div>
                </div>
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
        <NewsList :list="list" />
        <div class="loadMore">
          {{isLoading ? '———— 加载更多... ————' : (lastDataId == -1 ? '———— 已经到底了 ————' : '———— 上拉加载更多 ————')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/js/swiper.min.js';
import 'swiper/css/swiper.css';
import NewsList from "@/components/NewsList";
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { mapMutations, mapState } from 'vuex';
export default {
  name: "Home",
  components: {
    NewsList,
    Header,
    Footer
  },
  data() {
    return {
      isLoading: false,
      swiperData: [],
      swiper: null,
      matrixSwiper: null,
      beforeList: [],
      page: 1,
      list: [],
      lastDataId: null,
      subjectLastId: null,
      recommendColumn: [],
      subjectList: null,
      rankList: null, // 辟谣榜单
      aside_fixed: false,
      aside_absolute: false,
      imgLoaded: `this.style.background = 'none'`,
      errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"'
    };
  },
  created() {
    document.title = "川渝互联网联动辟谣平台";
  },
  mounted() {
    // if(!this.isPhone && this.lastDataId != -1) {
    //   this.$Common.loadScroll(300, this.update)
    // } else if(this.isPhone && this.lastDataId != -1) {
    //   this.$Common.loadScroll(0, this.update)
    // }
    this.isPhone && this.$Common.onShare({
      shareTitle: '川渝互联网联动辟谣平台',
      shareUrl: window.location.href
    })
    if (!this.isPhone && !this.matrixSwiper) {
      this.$nextTick(() => {
        this.matrixSlide()
      })
    }
    if(this.indexChannel && this.indexChannel.id) {
      this.getBanner();
      this.getNewsList();
      if(!this.isPhone) this.getSubjectList();
    }
  },
  methods: {
    ...mapMutations(['setLoadingShow']),
    mouseEnter(i) {
      if(!this.swiper) return;
      this.swiper.slideToLoop(i);
    },
    getBanner() {
      this.$axios.post(
        this.$ApiInfo.getBanner,
        {
          channelId: this.indexChannel.id
        }
      ).then(data => {
        if (data && data.length) {
       
          this.swiperData = data.slice(0, 4);
        }
      })
    },
    getNewsList() {
      this.$axios.post(
        this.$ApiInfo.getScChannelNewsList,
        {
          page: this.page, // 当前页数
          pageSize: this.pageSize, // 每页条数
          lastDataId: this.lastDataId, // 最后条记录id
          channelId: this.$Common.Base64.decode(this.indexChannel.channelId),
          channelType: this.$Common.Base64.decode(this.indexChannel.channelType),
        }
      ).then(data => {
        this.lastDataId = data.lastDataId;
        this.page++;
        if(data.list && data.list.length) {
          if(this.isPhone) {
            this.list = data.list;
            this.setLoadingShow(false)
            this.$nextTick(() => {
              this.swiperData && this.swiperData.length && this.slide();
              let footerHeight = 0;
              document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 100)
              this.$Common.loadScroll(footerHeight, this.update)
            })
            return;
          }
          if((this.hasSubject && data.list.length <= 6) || (!this.hasSubject && data.list.length <=8)) {
            this.beforeList = data.list
          } else {
            this.beforeList = this.hasSubject ? data.list.slice(0, 6) : data.list.slice(0, 8);
            this.list = this.hasSubject ? data.list.slice(6) : data.list.slice(8)
          }
        }
        this.setLoadingShow(false)
        this.$nextTick(() => {
          this.swiperData && this.swiperData.length && this.slide();
          // let footerHeight = 0;
          // document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 100)
          // this.$Common.loadScroll(footerHeight, this.update)
        })
      })
    },
    update() {
      if(this.lastDataId == -1 || this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.$axios.post(
        this.$ApiInfo.getScChannelNewsList,
        {
          page: this.page, // 当前页数
          pageSize: this.pageSize, // 每页条数
          lastDataId: this.lastDataId, // 最后条记录id
          channelId: this.$Common.Base64.decode(this.indexChannel.channelId),
          channelType: this.$Common.Base64.decode(this.indexChannel.channelType),
        }
      ).then(data => {
        this.lastDataId = data.lastDataId;
        this.page++;
        data.list && data.list.length && (this.list.push(...data.list));
        this.isLoading = false;
        if (!this.isPhone) {
          this.$nextTick(() => {
            this.watchSubject()
          })
        }
      })
    },
    getRecommendColumn() {
      let data = [];
      let filterList = [];
      if(this.columnList && this.columnList.length) {
        filterList = this.columnList.filter(v => v.type != 2);
        filterList.length && (data = filterList.slice(0, 5))
      }
      this.recommendColumn = data.slice;
      data.length && this.getColumnNews(data);
    },
    getColumnNews(data) {
      data.map(v => {
        this.$axios.post(
          this.$ApiInfo.getSubjectDetail,
            {
                id: v.id,
                page: 1,
                pageSize: 5,
                skNewsListPageSize: 10,
                lastDataId: this.lastDataId
            }
        ).then(data => {
            if(!data) return;
            if(!data.newsList && data.subjectKindList) {
              data.newsList = data.subjectKindList.reduce((t, v) => {
                return t.concat(v.newsList || [])
              }, []);
            }
            this.recommendColumn.map((rv, ri) => {
              if(rv.id == data.id) {
                this.recommendColumn.splice(ri, 1, {
                  ...rv,
                  subject: data
                })
              }
            })
        })
      })
    },
    getSubjects() {
      this.$axios.post(
        this.$ApiInfo.getSubjects,
        {
          page: 1,
          pageSize: 4,
          lastDataId: this.subjectLastId
        }
      ).then(data => {
        data.list && data.list.length && (this.subjectList = data.list)
      })
    },
    slide() {
      let that = this
      if (this.isPhone) {
        this.swiper = new Swiper('.swiper-container', {
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          loop: true,
        })
        return
      }
      this.swiper = new Swiper('.banner-swiper', {
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        on: {
          click: function(e) {
            let domClass = e.target.className
            if (domClass && domClass.indexOf('arrow-wrapper') > -1) {
              return
            }
            let index = this.realIndex
            that.bannerClick(index)
          }
        },
        navigation: {
          nextEl: '.swiper-toRight',
          prevEl: '.swiper-toLeft',
        },
      })
    },
    matrixSlide() {
      return; // 屏蔽菜单路由更多
      if (this.colums && this.colums.length > 6) {
        this.matrixSwiper = new Swiper('.matrix-swiper', {
          slidesPerView : "auto",
          // slidesPerGroup : 6,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.maxtrix-swiper-toRight',
            prevEl: '.maxtrix-swiper-toLeft',
          },
        })
      }
    },
    bannerClick(index) {
      const item = this.swiperData[index]
      this.toNewsDetail(item, true)
    },
    toDetail(item, jumpSubject) {
      if(item.type == 1) {
        window.open(this.$router.resolve({ // 文章栏目
            path: `/list/1/${this.$Common.Base64.encode(item.id)}`
        })['href'], '_blank');
      } else if(item.type == 2) { // 外接栏目 - 外链
        window.open(item.externalUrl)
      } else if(item.type == 3) { // 分类栏目 - 外链集合
        window.open(this.$router.resolve({
            path: `/list/3/${this.$Common.Base64.encode(item.id)}`
        })['href'], '_blank');
      } else if(item.type == 4 || jumpSubject){
        window.open(this.$router.resolve({
            path: `/subject/${this.$Common.Base64.encode(item.subjectId || item.id)}`
        })['href'], '_blank');
      }else if(item.type == 5) { // 专题专栏集合栏目
        window.open(this.$router.resolve({
            path: `/list/6/${this.$Common.Base64.encode(item.id)}`
        })['href'], '_blank');
      } else if(item.type == 6) { // 自定义的type为6跳转所有专题页
        window.open(this.$router.resolve({
            path: `/list/4`
        })['href'], '_blank');
      } else if(item.type == 7) { // 自定义的type为7跳转所有频道页
        window.open(this.$router.resolve({
            path: `/list/7/${this.$Common.Base64.encode(item.id)}`,
            query: {
                channelId: this.$Common.Base64.encode(item.targetChannelId),
                channelType: this.$Common.Base64.encode(item.targetChannelType)
            }
        })['href'], '_blank');
      }
    },
    toNewsDetail(item, judgeSubject) {
      let url = '' 
      if(item.type == 3) {
        url = item.url
      } else if(judgeSubject && item.isSubjectEntrance) {
        url = this.$router.resolve({
              path: `/subject/${this.$Common.Base64.encode(item.subjectId || item.id)}`
          })['href']
      } else if(item.newsKind == 6) {
        url = item.externalUrl
      } else {
        url = this.$router.resolve({
              path: `/news/${this.$Common.Base64.encode(item.id)}`
          })['href']
      }
      if(this.isPhone){
        location.href = url
      }else{
        window.open(url, '_blank');
      }
    },
    toSubject(item) {
      window.open(this.$router.resolve({
          path: `/subject/${this.$Common.Base64.encode(item.id)}`
      })['href'], '_blank');
    },
    showSeeAll(item) { //规则 展示查看全部
      if(item.subject && item.subject.newsList) { //&& item.subject.newsList.length >= 5
        return true
      } else {
        return false
      }
    },
    getSubjectList() {
      this.$axios.post(
        this.$ApiInfo.getSubjectOfChannelIdAndEntryNews,
        {
          channelId: this.indexChannel.id
        }
      ).then(data => {
        if (data && data.length) {
          this.recommendColumn = data;
          this.getColumnNews(data);
          this.$nextTick(() => {
            window.addEventListener('scroll', this.watchSubject)
          })
        }
      })
    },
    watchSubject() {
      let subjectWrapper = document.getElementById('content-wrapper-right')
      let header = document.getElementById('header-wrapper')
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      if (scrollTop <= 0) {
        this.aside_fixed = false
        this.aside_absolute = false
        return
      }
      let footerHeight = 0;
      document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight)
      if (scrollTop >=  subjectWrapper.clientHeight) {
        if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop))
          + (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
          >= (document.documentElement.scrollHeight || document.body.scrollHeight) - footerHeight
        ) {
          this.aside_absolute = true
          this.aside_fixed = false
        } else {
          this.aside_fixed = true
          this.aside_absolute = false
        }
      } else {
        this.aside_fixed = false
        this.aside_absolute = false
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.watchSubject)
  },
  computed: {
    ...mapState(['indexChannel', 'columnList']),
    colums() {
      return this.columnList
    },
    hasColumn() {
      return this.columnList && this.columnList.length
    },
    column() {
      return this.hasColumn ? 3 : 4
    },
    isPhone() {
      return this.$Common.Attribute.isMb()
    },
    pageSize() {
      return this.isPhone ? 20 : 48
    },
    hasSubject() { // 默认专题数据是否存在
      return this.recommendColumn.length > 0
    },
    isProduction() {
      return location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
    },
    asideSubjectIds() {
      if (this.isProduction) {
        return [242, 243, 244, 245, 246]
      }
      return [317, 318, 309, 286, 305]
    }
  },
  watch: {
    indexChannel(val) {
      if(val.id) {
        this.getBanner();
        this.getNewsList();
        if(!this.isPhone) this.getSubjectList();
      };
    },
    colums(val) {
      if (val && val.length && !this.isPhone) {
        this.$nextTick(() => {
          this.matrixSlide()
        })
      }
    }
  }
};
</script>
<style lang="less">
.page-home {
  .pc {
    .imgcenter {
      width: 100%;
      height: 13.875rem;
      background: linear-gradient(329deg, #006DF1 0%, #007AF6 100%);
    }
    .content-wrapper {
      position: relative;
      .swiper-pagination {
          box-sizing: border-box;
          text-align: right;
          padding-right: 0.625rem;
          .swiper-pagination-bullet {
            width: 0.375rem;
            height: 0.375rem;
            background: #D8D8D8;
            opacity: 1;
            outline: none;
          }
          .swiper-pagination-bullet-active {
            background: #006DF1;
          }
      }
      .common-title {
        // border-bottom: 1px solid #eee;
        font-size: 1.25rem;
        margin-bottom: 1.25rem;
        padding-bottom: 0.25rem;
        position: relative;
        font-weight: bold;
        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 0.38rem;
          background: linear-gradient(90deg, #006DF1 0%, #ffffff 100%);
        }
        span {
          color: #000;
          // border-bottom: 1px solid #006df1;
          // padding-left: .25rem;
          line-height: 2.5rem;
        }
      }
      .content-wrapper-left {
        width: 47.625rem;
        float: left;
        .swiperBanner-piyaoRankList {
          .swiper-container {
            width: 24.25rem;
            height: 13.6875rem;
            .swiper-slide {
              .img {
                .video-icon {
                    position: absolute;
                    width: 3.1875rem;
                    height: 3.1875rem;
                    background: url('../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
              }
              .title {
                width: 100%;
                padding: 1.75rem 2.0625rem .5625rem;
                box-sizing: border-box;
                color: #ffffff;
                font-size: .875rem;
                line-height: 1.25rem;
                position: absolute;
                bottom: 0;
                left: 0;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                .tyBannerlabel {
                  padding: 0.125rem 0.375rem;
                  font-size: 0.75rem;
                  text-align: center;
                  color: #fff;
                  background: linear-gradient(149deg, #2479FF 0%, #244EFF 100%);
                }
              }
            }
            .swiper-arrow {
              width: 1.8rem;
              height: 1.8rem;
              position: absolute;
              bottom: 0.24rem;
              z-index: 99;
              outline: none;
              cursor: pointer;
            }
            .swiper-toLeft {
              left: .2625rem;
              div {
                display: block;
                content: '';
                width: .5625rem;
                height: .5625rem;
                border-top: 2px solid #ffffff;
                border-left: 2px solid #ffffff;
                transform: rotate(-45deg);
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
              }
            }
            .swiper-toRight {
              right: .2625rem;
              div {
                display: block;
                content: '';
                width: .5625rem;
                height: .5625rem;
                border-top: 2px solid #ffffff;
                border-right: 2px solid #ffffff;
                transform: rotate(45deg);
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
              }
            }
            .swiper-button-disabled {
              
            }
          }
          .piyaoRankList {
            height: 13.6875rem;
            .title {
              height: 2.375rem;
              color: #ffffff;
              font-size: 1.25rem;
              line-height: 2.375rem;
              font-weight: bold;
              letter-spacing: .2125rem;
              background: linear-gradient(201deg, #00A6F9 0%, #006DF1 100%);
              text-align: center;
            }
            .list {
              padding: .875rem;
              background: #F9F9F9;
              height: 11.3125rem;
              box-sizing: border-box;
              .list-item {
                font-size: .9375rem;
                color: #333333;
                line-height: 1.25rem;
                margin-bottom: .9375rem;
                .indexNum {
                  color: #FA6400;
                  font-weight: bold;
                  float: left;
                }
                .color-gray {
                  color: #999999;
                }
                .newsTitle {
                  margin-left: 1.125rem;
                }
                &:last-of-type {
                  margin-bottom: 0;
                }
              }
            }
          }
          .hasBnnnerRanking {
            width: 22.75rem;
            float: right;
          }
        }
        .column-matrix {
          margin-top: 1.25rem;
          .list {
            // margin-left: -1.375rem;
            padding: 0 1.25rem;
            position: relative;
            .matrix-swiper {
              width: 100%;
              // height: 2.75rem;
              .swiper-wrapper {
                width: 100%;
                height: 100%;
                .swiper-slide {
                  display: inline-block;
                  width: auto;
                  margin-right: .75rem;
                  // overflow: hidden;
                  .columnOnlyImg {
                    width: 6.875rem;
                    height: 2.75rem;
                    border-radius: 0.3125rem;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    transition: all .3s;
                    &:hover {
                      transform: scale(1.1);
                    }
                  }
                  .columnImgText {
                    width: 5.875rem;
                    text-align: center;
                    .img {
                      display: inline-block;
                      width: 3.875rem;
                      height: 3.875rem;
                      // border-radius: 50%;
                      margin-bottom: .5rem;
                      background-size: cover;
                      background-position: center;
                      background-repeat: no-repeat;
                      transition: all .3s;
                      &:hover {
                        transform: scale(1.12);
                      }
                    }
                    .text {
                      font-size: .875rem;
                      color: #000;
                      text-align: center;
                    }
                  }
                }
              }
            }
            .swiper-arrow {
              width: .75rem;
              height: 100%;
              background: #308EFF;
              border-radius: .25rem;
              position: absolute;
              top: 0;
              outline: none;
              cursor: pointer;
              div {
                width: .25rem;
                height: .25rem;
                position: absolute;
                color: #ffffff;
                border-top: 1px solid #ffffff;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
              }
            }
            .swiper-toLeft {
              div {
                left: 1px;
                border-left: 1px solid #ffffff;
                transform: rotate(-45deg);
              }
              left: 0;
            }
            .swiper-toRight {
              div {
                right: 1px;
                border-right: 1px solid #ffffff;
                transform: rotate(45deg);
              }
              right: 0;
            }
            .swiper-button-disabled {
              opacity: .4;
            }
          }
          .noPadding {
            padding: 0;
          }
        }
        .noBanner-column-matrix {
          margin-top: -0.625rem;
        }
        .latest-kill-rumor {
          .list {
            .list-subject {
              width: 100%;
              height: 16.875rem;
              background: #eee;
              margin-bottom: 1.5rem;
              background: url('./../assets/img/new_subject_recommond_bg.png') center no-repeat;
              background-size: cover;
              box-sizing: border-box;
              padding: 1.1875rem;
              .title-load {
                color: #006DF1;
                .title {
                  font-size: 1.125rem;
                  line-height: 1.125rem;
                  padding-left: 0.375rem;
                  border-left: 0.25rem solid #006DF1;
                  float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  line-height: 1.125rem;
                  float: right;
                  color: #666666;
                  &::after {
                    display: inline-block;
                    content: '';
                    border-top: 1px solid #666666;
                    border-right: 1px solid #666666;
                    width: .25rem;
                    height: .25rem;
                    transform: rotate(45deg);
                    margin-bottom: 2px;
                  }
                }
              }
              .content {
                margin-top: 0.6875rem;
                .left {
                  width: 22.25rem;
                  height: 12.5625rem;
                  float: left;
                  position: relative;
                  overflow: hidden;
                  &:hover img{
                    transform: scale(1.1);
                  }
                  img {
                    transition: all .3s; 
                  }
                  .title {
                    position: absolute;
                    bottom: 0;
                    color: #fff;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 1.5rem 0.75rem 0.4375rem;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                  }
                }
                .right {
                  width: 22.25rem;
                  height: 12.5625rem;
                  float: right;
                  .news {
                    height: 3.75rem;
                    margin-bottom: 0.625rem;
                    position: relative;
                    &:hover {
                      img {
                        transform: scale(1.2);
                      }
                      .title {
                        color: #006DF1;
                      }
                    }
                    .img {
                      width: 6.625rem;
                      height: 100%;
                      overflow: hidden;
                      float: left;
                      img {
                        transition: all .3s;
                      }
                    }
                    .title {
                      margin-left: 7rem;
                      height: 100%;
                      font-size: 0.875rem;
                      color: #333333;
                      line-height: 1.25rem;
                      padding-top: 0.25rem;
                      box-sizing: border-box;
                    }
                    .label {
                      top: 1px;
                      left: 1px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .content-wrapper-right {
        float: right;
        width: 15.375rem;
        background-color: #ffffff;
        .aside-subject {
          margin-bottom: 1.25rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          .title {
            font-size: 1.3125rem;
            // line-height: 1.1875rem;
            // padding-left: 0.5rem;
            // border-left: 0.25rem solid #2470FF;
            color: #2470FF;
            font-weight: 500;
            padding-bottom: .4375rem;
            border-bottom: 1px solid #2470FF;
            display: flex;
            align-items: center;
            .title-name {
              width: 80%;
              margin-right: 1%;
              line-height: 1.3125rem;
            }
            &::before {
              display: inline-block;
              content: '';
              width: 0.25rem;
              height: 1.1875rem;
              background: #2470FF;
              margin-right: 0.5rem;
            }
            .seeMore {
              color: #999999;
              font-size: .6875rem;
              cursor: pointer;
            }
          }
          .news-part {
            margin-top: 0.9375rem;
            padding: 1.1875rem 0.9375rem;
            background: #f6f8fd;
            .news {
              margin-bottom: 1.25rem;
              &:hover {
                .news-title {
                  color: #006DF1;
                }
              }
              &:last-of-type {
                margin-bottom: 0;
              }
              .news-title {
                font-size: 0.8125rem;
                color: #333333;
                line-height: 1.3125rem;
                max-height: 2.625rem;
                margin-bottom: 0.3125rem;
                font-weight: 500;
              }
              .news-meta {
                font-size: 0.75rem;
                color: #999999;
                span {
                  margin-right: 0.3125rem;
                }
              }
            }
          }
          .seeAll {
            width: 5.63rem;;
            height: 1.88rem;
            border-radius: 0.13rem;
            border: 0.06rem solid #C6C6C6;
            line-height: 1.88rem;
            text-align: center;
            font-size: 0.625rem;
            color: #191919;
            margin: 0 auto;
            &:hover {
              background: #006DF1;
              color: #ffffff;
            }
          }
        }
      }
      .aside_fixed {
        position: fixed;
        bottom: 0;
        right: 14.375rem;
      }
      .aside_absolute {
        position: absolute;
        bottom: 2.5rem;
        right: 0;
      }
      .swiperBanner {
        width: 100%;
        display: flex;
        align-items: top;
        background: #f6f8fd;
        margin-bottom: 1.25rem;
        .swiper-container {
          width: 48.63rem;
        }
        .swiper-title {
          width: 15.38rem;
          height: 27.35rem;
          display: flex;
          flex-direction: column;
          overflow-y: hidden;
          // &.spaceBetween {
          //   justify-content: space-between;
          // }
          &-item {
            padding: 0 1rem;
            cursor: pointer;
            height: 25%;
            display: flex;
            align-items: center;
            overflow: hidden;
            &.active {
              background: #006df1;
              color: #ffffff;
              .desc {
                color: #ffffff;
              }
            }
            .title {
              font-weight: bold;
              margin-bottom: 0.5rem;
              font-size: 1rem;
            }
            .desc {
              font-size: 0.6rem;
              color: #666666;
              display: flex;
              line-height: 1.3;
              .sourcename {
                margin-right: 1rem;
              }
              .publishtime {
                white-space: nowrap;
              }
            }
          }
        }
        .swiper-slide {
          height: 27.35rem;
          .img {
            width: 100%;
            height: 100%;
            float: left;
            position: relative;
            .video-icon {
                position: absolute;
                width: 3.1875rem;
                height: 3.1875rem;
                background: url('../assets/img/video_play.png') center no-repeat;
                background-size: cover;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
          }
          .title {
            width: 16rem;
            height: 100%;
            padding: 2.125rem 1.4375rem;
            box-sizing: border-box;
            float: left;
            background: #fff;
            color: #333333;
            font-size: 1.25rem;
            line-height: 1.875rem;
          }
        }
      }
      .content-wrapper-NC {
        .latest-kill-rumor {
          margin-top: 1.25rem;
          .list {
            .list-subject {
              width: 100%;
              height: 19.75rem;
              background: #eee;
              margin-bottom: 1.5rem;
              background: url('./../assets/img/new_subject_recommond_bg.png') center no-repeat;
              background-size: cover;
              box-sizing: border-box;
              padding: 1.1875rem;
              .title-load {
                color: #006DF1;
                .title {
                  font-size: 1.125rem;
                  line-height: 1.125rem;
                  padding-left: 0.375rem;
                  border-left: 0.25rem solid #006DF1;
                  float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  line-height: 1.125rem;
                  float: right;
                  color: #666666;
                  img {
                    width: 0.3125rem;
                    height: 0.4375rem;
                  }
                }
              }
              .content {
                margin-top: 0.6875rem;
                .left {
                  width: 28.375rem;
                  height: 16rem;
                  float: left;
                  position: relative;
                  overflow: hidden;
                  &:hover img{
                    transform: scale(1.1);
                  }
                  img {
                    transition: all .3s; 
                  }
                  .title {
                    position: absolute;
                    bottom: 0;
                    color: #fff;
                    box-sizing: border-box;
                    padding: 1.5rem 0.75rem 0.4375rem;
                    width: 100%;
                    box-sizing: border-box;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                  }
                }
                .right {
                  width: 32.875rem;
                  height: 16rem;
                  float: right;
                  .news {
                    height: 4.875rem;
                    margin-bottom: 0.6875rem;
                    position: relative;
                    &:hover .img img{
                      transform: scale(1.2);
                    }
                    .img {
                      width: 8.625rem;
                      height: 100%;
                      overflow: hidden;
                      float: left;
                      img {
                        transition: all .3s;
                      }
                    }
                    .title {
                      margin-left: 9.25rem;
                      height: 100%;
                      font-size: 0.875rem;
                      color: #333333;
                      line-height: 1.25rem;
                      padding-top: 0.625rem;
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .wap {
    .content-wrapper {
      .swiper-container {
        .swiper-wrapper {
          .swiper-slide {
            position: relative;
            width: 100vw;
            .img {
              width: 100vw;
              height: 56.267vw;
              position: relative;
              .video-icon {
                  position: absolute;
                  width: 11.667vw;
                  height: 11.667vw;
                  background: url('../assets/img/video_play.png') center no-repeat;
                  background-size: cover;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
              }
            }
            .title {
              position: absolute;
              bottom: 0;
              font-size: 4.533vw;
              line-height: 6.4vw;
              color: #fff;
              width: 100vw;
              box-sizing: border-box;
              padding: 6.8vw 4vw 6.4vw;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
              .titleName {
                height: 12.8vw;
              }
            }
          }
        }
        .swiper-pagination {
            box-sizing: border-box;
            text-align: right;
            padding-right: 8px;
            .swiper-pagination-bullet {
              width: 6px;
              height: 6px;
              background: #D8D8D8;
              opacity: 0.5;
              outline: none;
            }
            .swiper-pagination-bullet-active {
              background: #006DF1;
              opacity: 0.7;
            }
        }
      }
    }
  }
  @media screen and (max-width: 1550px) {
    .pc .swiper-title-item {
      line-height: 1.2 !important;
    }
  }
  @media screen and (max-width: 1100px) {
    .pc .swiper-title-item {
      line-height: 1 !important;
      .title {
        font-size: 0.8rem !important;
      }
      .desc  {
        font-size: 0.4rem !important;
      }
    }
  }
  @media screen and (max-width: 900px) {
    .pc .swiper-title-item {
    }
  }
}
</style>